import reducer from "./reducer";
export { default as FamilyGroup } from "./components/index";
export { default as familyGroupReducerName } from "./constants";
export default reducer;
